import BaseAction from '@/actions/base_action.js'

export default class extends BaseAction {
  execute(properties, component) {
    const promise = $tpu.r.checklists.destroy(
      properties.checklistId,
      properties.cardId)
    this.executeCardUpdate(promise, properties, component, false)
  }
}
